import { Component } from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import { Location }                 from '@angular/common';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {ProductService} from "./services/product.service";
import {Product} from "./model/Product";
import {Photo} from "./model/Photo";
import {Type} from "./model/Type";
import {TypeService} from "./services/type.service";

import 'rxjs/add/operator/switchMap';
import {FileHolder} from "angular2-image-upload/lib/image-upload/image-upload.component";
import {PhotoService} from "./services/photo.service";
import {AuthenticationService} from "./services/authentication.service";

@Component({
    selector: 'app-admin-login',
    templateUrl: './admin-login.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [AuthenticationService]
})

export class AdminLoginComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    title = 'Login';

    emailLogin: string;
    password: string;

    ngOnInit(): void {
        this.authenticationService.logout();
    }


    constructor(
        private router: Router,
        private authenticationService: AuthenticationService) { }


    login() {
        this.loading = true;
        this.authenticationService.login(this.emailLogin, this.password)
            .then(result => {
                if (result === true) {
                    this.router.navigate(['/admin-manage-products']);
                } else {
                    this.error = 'Username or password is incorrect';
                    this.loading = false;
                }
            }, (error) => {
                this.error = error.message;
                this.loading = false;
                console.error(error);
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/admin-login.component.ts